module.exports = __webpack_public_path__ + "media/src/pages/Onboarding/images/ocean-1997ced31041092aff694dd07236aee1.png";